/**
 * Created by Andrey Popov on 12/28/22.
 */

const CardsCounterView = cleverapps.Layout.extend({
    ctor: function (cardCounter) {
        this.cardCounter = cardCounter;

        // eslint-disable-next-line no-restricted-syntax
        const caption = cleverapps.UI.generateTTFText("Cards: ", cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);
        // eslint-disable-next-line no-restricted-syntax
        const value = cleverapps.UI.generateTTFText("_____", cleverapps.styles.FONTS.EDITOR_BLUE_TEXT);

        cardCounter.onRefresh = this.createListener(() => {
            value.setFontFillColor(cardCounter.isValid ? cleverapps.styles.COLORS.COLOR_BLUE : cleverapps.styles.COLORS.DARK_RED);
            value._setUpdateTextureDirty();

            value.setString(cardCounter.countOfCards + (cardCounter.isValid ? "" : "!"));
        });

        cleverapps.UI.applyHover(this, {
            onMouseOver: this.onMouseOver.bind(this),
            onMouseOut: this.onMouseOut.bind(this)
        });

        this._super([caption, value], {
            direction: cleverapps.UI.HORIZONTAL
        });

        cardCounter.onRefresh();
    },

    onMouseOver: function () {
        if (this.hint) {
            this.hint.removeFromParent();
        }

        if (!this.cardCounter.isValid) {
            this.hint = new cleverapps.UI.Tooltip(this.background, {
                text: `Should be from ${this.cardCounter.lowValidValue} to ${this.cardCounter.upValidValue}`,
                size: cleverapps.styles.UI.Button.tooltipSize,
                location: cleverapps.UI.Tooltip.LOCATION_ABOVE
            });
            cleverapps.Scenes.GetRunningScene().movingNode.addChild(this.hint);
        }
    },

    onMouseOut: function () {
        if (this.hint) {
            this.hint.removeFromParent();
        }
    }
});